import i18n from '@/utils/i18n';
import { formMethods } from "@/mixins/form";
import { format } from "@/mixins/format";

const fields = {
  business: {
    title: i18n.t('resources.block_titles.business_info'),
    columns: 6,
    items: [
      {
        name: 'title',
        type: 'text',
        main: true,
        required: false,
        label: i18n.t('resources.business_name'),
      },
      {
        name: 'code',
        type: 'text',
        main: true,
        required: false,
        label: i18n.t('resources.business_code'),
      },
      {
        name: 'contact_phone',
        type: 'text',
        main: true,
        required: false,
        label: i18n.t('resources.contact_phone'),
      },
      {
        name: 'contact_email',
        type: 'email',
        main: true,
        required: false,
        label: i18n.t('resources.contact_email'),
      },
      {
        name: 'address_country',
        type: 'text',
        main: true,
        required: false,
        label: i18n.t('resources.address_country'),
      },
      {
        name: 'address_city',
        type: 'text',
        main: true,
        required: false,
        label: i18n.t('resources.address_city'),
      },
      {
        name: 'address_line',
        type: 'text',
        main: true,
        required: false,
        label: i18n.t('resources.address_line'),
      },
    ],
  },
  general: {
    title: i18n.t('resources.block_titles.general_info'),
    columns: 3,
    items: [
      {
        name: 'title',
        type: 'text',
        main: true,
        required: true,
        label: i18n.t('resources.publication_name'),
      },
      {
        name: 'host',
        type: 'url',
        main: true,
        required: true,
        label: i18n.t('resources.url'),
      },
      {
        name: 'public_key',
        type: 'text',
        disabled: true,
        main: true,
        label: i18n.t('resources.public_key'),
      },
      {
        name: 'private_key',
        type: 'text',
        disabled: true,
        main: true,
        label: i18n.t('resources.private_key'),
      },
      {
        name: 'invitation_landing_url',
        type: 'text',
        main: true,
        label: i18n.t('resources.invitation_landing_url'),
      },
    ],
  },
  predictivePaywall: {
    title: i18n.t('resources.block_titles.predictive_paywall'),
    columns: 3,
    items: [
      {
        name: 'weight_content_conversion_rate',
        value: 0,
        type: 'text',
        main: true,
        required: false,
        label: i18n.t('resources.content_conversion_rate'),
      },
      {
        name: 'weight_content_signups_rate',
        value: 0,
        type: 'text',
        disabled: false,
        main: true,
        required: false,
        label: i18n.t('resources.content_signups_rate'),
      },
      {
        name: 'weight_taxonomy_conversion_rate',
        value: 0,
        type: 'text',
        main: true,
        required: false,
        label: i18n.t('resources.taxonomy_conversion_rate'),
      },
      {
        name: 'weight_taxonomy_signups_rate',
        value: 0,
        type: 'text',
        main: true,
        required: false,
        label: i18n.t('resources.weight_taxonomy_signups_rate'),
      },
      {
        name: 'weight_user_resource_transaction_rate',
        value: 0,
        type: 'text',
        main: true,
        required: false,
        label: i18n.t('resources.user_resource_transaction_rate'),
      },
      {
        name: 'weight_user_transaction_rate',
        value: 0,
        type: 'text',
        main: true,
        required: false,
        label: i18n.t('resources.user_transaction_rate'),
      },
      {
        name: 'weight_user_resource_ltv_rate',
        value: 0,
        type: 'text',
        main: true,
        required: false,
        label: i18n.t('resources.user_resource_ltv_rate'),
      },
      {
        name: 'weight_user_ltv_rate',
        value: 0,
        type: 'text',
        main: true,
        required: false,
        label: i18n.t('resources.weight_user_ltv_rate'),
      },
      {
        name: 'weight_user_resource_activity_rate_last_seven',
        value: 0,
        type: 'text',
        main: true,
        required: false,
        label: i18n.t('resources.user_resource_activity_rate_last_seven'),
      },
      {
        name: 'weight_user_resource_activity_rate_last_thirty',
        value: 0,
        type: 'text',
        main: true,
        required: false,
        label: i18n.t('resources.user_resource_activity_rate_last_thirty'),
      },
      {
        name: 'weight_user_resource_count_paywall_last_ninety',
        value: 0,
        type: 'text',
        main: true,
        required: false,
        label: i18n.t('resources.user_resource_count_paywall_last_ninety'),
      },
    ],
  },
  firebase: {
     title: i18n.t('resources.block_titles.firebase_settings'),
  },
  settings: {
    title: i18n.t('resources.block_titles.system_settings'),
    columns: 12,
    items: [
      {
        name: 'external_auth_url',
        type: 'text',
        label: i18n.t('resources.external_auth_url'),
      },
      {
        name: 'single_subscription',
        type: 'checkbox',
        label: i18n.t('resources.single_subscription'),
      },
      {
        name: 'default_autorenewal_subscription',
        type: 'checkbox',
        label: i18n.t('resources.default_autorenewal_subscription'),
      },
      {
        name: 'default_autorenewal_teams_subscription',
        type: 'checkbox',
        label: i18n.t('resources.default_autorenewal_teams_subscription'),
      },
      {
        name: 'auto_attach_customer_to_resource',
        type: 'checkbox',
        label: i18n.t('resources.auto_attach_customer_to_resource'),
      },
      {
        name: 'remove_all_session_on_logout',
        type: 'checkbox',
        label: i18n.t('resources.remove_all_session_on_logout'),
      },
      {
        name: 'use_group_users_country',
        type: 'checkbox',
        label: i18n.t('resources.use_group_users_country'),
      },
      {
        name: 'auto_allowed_domains_for_team',
        type: 'checkbox',
        label: i18n.t('resources.auto_allowed_domains_for_team'),
      },
      {
        name: 'auto_clear_content_views',
        type: 'checkbox',
        label: i18n.t('resources.auto_clear_content_views'),
      },
      {
        name: 'firebase_auth',
        type: 'checkbox',
        label: i18n.t('resources.firebase_auth'),
      },
      {
        name: 'delete_payment_method_if_blocked',
        type: 'checkbox',
        label: i18n.t('resources.delete_payment_method_if_blocked'),
      },
    ],
  },
  root_settings: {
    title: i18n.t('resources.block_titles.root_system_settings'),
    columns: 4,
    items: [
      {
        name: 'content_sync_and_check',
        type: 'checkbox',
        label: i18n.t('resources.content_sync_and_check'),
      },
      {
        name: 'ti_events_system',
        type: 'checkbox',
        label: i18n.t('resources.ti_events_system'),
      },
      {
        name: 'allow_email_auth_skip_mail_without_sessions',
        type: 'checkbox',
        label: i18n.t('resources.allow_email_auth_skip_mail_without_sessions'),
      },
    ],
  },
  recaptcha: {
    title: 'ReCaptcha',
    columns: 4,
    items: [
      {
        name: 'active',
        type: 'checkbox',
        className: 'mb-2',
        label: i18n.t('resources.use_recaptcha'),
      },
      {
        name: 'recaptcha_secret_key',
        type: 'text',
        label: i18n.t('resources.secret_key'),
      },
      {
        name: 'recaptcha_public_key',
        type: 'text',
        label: i18n.t('resources.public_key'),
      },
    ],
  },

  compromised_sessions: {
    title: i18n.t('resources.block_titles.compromised_sessions'),
    columns: 4,
    items: [
      {
        name: 'limit_device_authorization',
        type: 'select',
        label: i18n.t('resources.limit_device_authorization'),
        options: [
          {
            value: 0,
            name: i18n.t('resources.unlimited'),
          },
          {
            value: 1,
            name: '1',
          },
          {
            value: 2,
            name: '2',
          },
          {
            value: 3,
            name: '3',
          },
          {
            value: 4,
            name: '4',
          },
          {
            value: 5,
            name: '5',
          },
          {
            value: 6,
            name: '6',
          },
          {
            value: 7,
            name: '7',
          },
          {
            value: 8,
            name: '8',
          },
          {
            value: 9,
            name: '9',
          },
          {
            value: 10,
            name: '10',
          },
        ],
      },
      {
        name: 'compromised_period',
        type: 'select',
        label: i18n.t('resources.compromised_period'),
        options: [
          {
            value: '1 day',
            name: i18n.t('global.day', { number: 1 }),
          },
          {
            value: '2 days',
            name: i18n.t('global.day', { number: 2 }),
          },
          {
            value: '3 days',
            name: i18n.t('global.day', { number: 3 }),
          },
          {
            value: '4 days',
            name: i18n.t('global.day', { number: 4 }),
          },
          {
            value: '5 days',
            name: i18n.t('global.day', { number: 5 }),
          },
          {
            value: '6 days',
            name: i18n.t('global.day', { number: 6 }),
          },
          {
            value: '7 days',
            name: i18n.t('global.day', { number: 7 }),
          },
          {
            value: '8 days',
            name: i18n.t('global.day', { number: 8 }),
          },
        ],
        hideIfNotEmpty: 'limit_device_authorization',
      },
      {
        name: 'compromised_limit',
        type: 'number',
        min: 0,
        label: i18n.t('resources.compromised_limit'),
      },
    ],
  },
  plan: {
    title: i18n.t('resources.block_titles.subscription_settings'),
    columns: 3,
    items: [
      {
        name: 'default_subscription_id',
        type: 'select',
        label: i18n.t('resources.block_titles.default_plan'),
        searchable: false,
        group: true,
      },
      {
        name: 'downgrade_subscription_id',
        type: 'select',
        label: i18n.t('resources.block_titles.default_downgrade_plan'),
        searchable: false,
        group: true,
      },
      {
        name: 'default_guest_subscription_id',
        type: 'select',
        label: i18n.t('resources.block_titles.default_quest_plan'),
        searchable: false,
        group: true,
      },
      {
        name: 'delay_downgrade',
        type: 'select',
        searchable: false,
        clearable: false,
        label: i18n.t('resources.block_titles.grace_period'),
        options: [
          {
            value: '1 day',
            name: i18n.t('global.day', { number: 1 }),
          },
          {
            value: '2 days',
            name: i18n.t('global.days', { number: 2 }),
          },
          {
            value: '3 days',
            name: i18n.t('global.days', { number: 3 }),
          },
          {
            value: '4 days',
            name: i18n.t('global.days', { number: 4 }),
          },
          {
            value: '5 days',
            name: i18n.t('global.days', { number: 5 }),
          },
          {
            value: '6 days',
            name: i18n.t('global.days', { number: 6 }),
          },
          {
            value: '7 days',
            name: i18n.t('global.days', { number: 7 }),
          },
          {
            value: '8 days',
            name: i18n.t('global.days', { number: 8 }),
          },
          {
            value: '9 days',
            name: i18n.t('global.days', { number: 9 }),
          },
          {
            value: '10 days',
            name: i18n.t('global.days', { number: 10 }),
          },
          {
            value: '15 days',
            name: i18n.t('global.days', { number: 15 }),
          },
          {
            value: '30 days',
            name: i18n.t('global.days', { number: 30 }),
          },
        ],
      },
    ],
  },
  admin_emails: {
    title: i18n.t('resources.block_titles.email_notifications_admins'),
    columns: 5,
    items: [
      {
        name: 'email',
        type: 'email',
        label: i18n.t('resources.sender_email'),
      },
      {
        name: 'name',
        type: 'text',
        label: i18n.t('resources.sender_name'),
      },
    ],
  },
  moderator_emails: {
    title: i18n.t('resources.block_titles.moderator_emails'),
    columns: 5,
    items: [
      {
        name: 'email',
        type: 'email',
        label: i18n.t('resources.sender_email'),
      },
      {
        name: 'name',
        type: 'text',
        label: i18n.t('resources.sender_name'),
      },
    ],
  },
  emails_from: {
    title: i18n.t('resources.block_titles.emails_from'),
    columns: 6,
    items: [
      {
        name: 'name',
        type: 'text',
        label: i18n.t('resources.sender_name'),
      },
      {
        name: 'email',
        type: 'email',
        label:
          i18n.t('resources.sender_email') + ` (${i18n.t('resources.contact_manager_to_change')})`,
      },
    ],
  },
  emails_replay_to: {
    title: i18n.t('resources.block_titles.emails_replay_to'),
    columns: 6,
    items: [
      {
        name: 'name',
        type: 'text',
        label: i18n.t('resources.sender_name'),
      },
      {
        name: 'email',
        type: 'email',
        label: i18n.t('resources.sender_email'),
      },
    ],
  },
  mailhubspot: {
    title: i18n.t('resources.block_titles.hubspot_api_key'),
    icon: 'fab fa-hubspot',
    columns: 9,
    items: [
      {
        name: 'api_key',
        type: 'text',
        label: i18n.t('resources.key'),
      },
    ],
  },
  hubspot: {
    title: i18n.t('resources.block_titles.hubspot_api_key'),
    icon: 'fab fa-hubspot',
    columns: 9,
    items: [
      {
        name: 'api_key',
        type: 'text',
        label: i18n.t('resources.key'),
      },
    ],
  },
  streak: {
    title: i18n.t('resources.block_titles.streak_api_key'),
    icon: 'icon-streak',
    columns: 9,
    items: [
      {
        name: 'api_key',
        type: 'text',
        label: i18n.t('resources.key'),
      },
    ],
  },
  klaviyo: {
    title: 'Klaviyo',
    icon: 'icon-klaviyo',
    columns: 4,
    items: [
      {
        name: 'active',
        type: 'checkbox',
        className: 'mb-2',
        label: i18n.t('form.active'),
      },
      {
        name: 'public_key',
        type: 'text',
        label: i18n.t('resources.public_key'),
      },
      {
        name: 'secret_key',
        type: 'text',
        label: i18n.t('resources.secret_key'),
      },
      {
        name: 'paid_list_ids',
        type: 'text',
        label: i18n.t('resources.paid_list_ids'),
      },
      {
        name: 'free_list_ids',
        type: 'text',
        label: i18n.t('resources.free_list_ids'),
      },
    ],
  },
  activecampaign: {
    title: 'ActiveCampaign',
    icon: 'icon-activecampaign',
    columns: 4,
    items: [
      {
        name: 'active',
        type: 'checkbox',
        className: 'mb-2',
        label: i18n.t('form.active'),
      },
      {
        name: 'key',
        type: 'text',
        label: i18n.t('form.key'),
      },
      {
        name: 'account',
        type: 'text',
        label: i18n.t('form.account'),
      },
      {
        name: 'list_id',
        type: 'text',
        label: i18n.t('form.list_id'),
      },
    ],
  },
  beehiiv: {
    title: 'beehiiv',
    icon: 'icon-beehiiv',
    columns: 6,
    items: [
      {
        name: 'active',
        type: 'checkbox',
        className: 'mb-2',
        label: i18n.t('form.active'),
      },
      {
        name: 'token',
        type: 'text',
        label: i18n.t('form.token'),
      },
      {
        name: 'publication_id',
        type: 'text',
        label: i18n.t('form.publication_id'),
      },
    ],
  },
  mailchimp: {
    title: i18n.t('resources.block_titles.mailchimp_settings'),
    tooltipName: i18n.t('resources.block_titles.mailchimp_settings'),
    tooltipText: i18n.t('resources.tooltips.mailchimp_settings'),
    icon: 'fab fa-mailchimp',
    columns: 4,
    items: [
      {
        name: 'key',
        type: 'text',
        label: i18n.t('form.key'),
      },
      {
        name: 'name',
        type: 'text',
        label: i18n.t('form.name'),
      },
      {
        name: 'id',
        type: 'text',
        label: i18n.t('form.id'),
      },
    ],
  },
  segment: {
    title: i18n.t('resources.block_titles.segment_settings'),
    icon: 'icon-segment',
    columns: 8,
    items: [
      {
        name: 'write_key',
        type: 'text',
        label: i18n.t('form.key'),
      },
      {
        name: 'active',
        type: 'checkbox',
        className: 'mb-2',
        label: i18n.t('form.active'),
      },
    ],
  },
  slack: {
    title: i18n.t('resources.block_titles.slack_settings'),
    icon: 'fab fa-slack',
    tooltipName: i18n.t('resources.block_titles.slack_settings'),
    tooltipText: i18n.t('resources.tooltips.slack_settings'),
    columns: 4,
    items: [
      {
        name: 'webhook',
        type: 'url',
        label: i18n.t('resources.webhook'),
      },
      {
        name: 'channel',
        type: 'text',
        label: i18n.t('resources.channel'),
      },
      {
        name: 'username',
        type: 'text',
        label: i18n.t('resources.username'),
      },
    ],
  },
  stripe: {
    title: i18n.t('resources.block_titles.stripe_settings'),
    icon: 'fab fa-cc-stripe',
    general: {
      columns: 6,
      items: [
        {
          name: 'fees_include_in_total_price',
          type: 'switch',
          label: i18n.t('resources.include_wk_and_stripe_fees_in_total_price'),
          title: i18n.t('global.true'),
          titleFalse: i18n.t('global.false'),
        },
      ],
    },
    live: {
      title: i18n.t('resources.live'),
      columns: 6,
      items: [
        {
          name: 'public_key',
          type: 'text',
          label: i18n.t('resources.public_key'),
        },
        {
          name: 'private_key',
          type: 'text',
          label: i18n.t('resources.private_key'),
        },
      ],
    },
    test: {
      title: i18n.t('resources.test'),
      columns: 6,
      items: [
        {
          name: 'public_key',
          type: 'text',
          label: i18n.t('resources.public_key'),
        },
        {
          name: 'private_key',
          type: 'text',
          label: i18n.t('resources.private_key'),
        },
      ],
    },
  },
  stripe_connect: {
    title: i18n.t('resources.block_titles.stripe_settings'),
    icon: 'fab fa-cc-stripe',
    live: {
      title: i18n.t('resources.live'),
      columns: 6,
      items: [
        {
          name: 'public_key',
          type: 'text',
          label: i18n.t('resources.public_key'),
          disabled: true,
        },
        {
          name: 'private_key',
          type: 'text',
          label: i18n.t('resources.private_key'),
          disabled: true,
        },
      ],
    },
    test: {
      title: i18n.t('resources.test'),
      columns: 6,
      items: [
        {
          name: 'public_key',
          type: 'text',
          label: i18n.t('resources.public_key'),
          disabled: true,
        },
        {
          name: 'private_key',
          type: 'text',
          label: i18n.t('resources.private_key'),
          disabled: true,
        },
      ],
    },
    fee_wallkit: {
      columns: 12,
      items: [
        {
          name: 'stripe_connect_fee',
          type: 'number',
          step: '0.1',
          max: 100,
          min: 0,
          label: i18n.t('transactions.connect_fee') + ', %',
          formatter: (value) => {
            if (value < 0) return 0;
            if (value > 100) return 100;

            return value;
          },
        },
      ],
    },
    fee_ti_event: {
      columns: 12,
      items: [
        {
          name: 'stripe_connect_fee_ti_event',
          type: 'number',
          step: '0.1',
          max: 100,
          min: 0,
          label: i18n.t('transactions.connect_fee_ti_event') + ', %',
          formatter: (value) => {
            if (value < 0) return 0;
            if (value > 100) return 100;

            return value;
          },
        },
      ],
    },
    sent_receipts: {
      columns: 6,
      items: [
        {
          name: 'stripe_sent_receipts',
          type: 'checkbox',
          className: 'mb-2',
          label: i18n.t('resources.stripe_sent_receipts'),
        },
      ],
    },
  },
  square: {
    title: i18n.t('resources.block_titles.square_settings'),
    icon: 'fab fa-cc-square',
    live: {
      title: i18n.t('resources.live'),
      columns: 6,
      items: [
        {
          name: 'app_id',
          type: 'text',
          label: i18n.t('resources.app_id'),
        },
        {
          name: 'location_id',
          type: 'text',
          label: i18n.t('resources.location_id'),
        },
        {
          name: 'access_token',
          type: 'text',
          label: i18n.t('resources.access_token'),
        },
      ],
    },
    test: {
      title: i18n.t('resources.test'),
      columns: 6,
      items: [
        {
          name: 'app_id',
          type: 'text',
          label: i18n.t('resources.app_id'),
        },
        {
          name: 'location_id',
          type: 'text',
          label: i18n.t('resources.location_id'),
        },
        {
          name: 'access_token',
          type: 'text',
          label: i18n.t('resources.access_token'),
        },
      ],
    },
  },
  default_payment_system: {
    title: i18n.t('resources.block_titles.payment_systems_settings'),
    description: i18n.t('resources.descriptions.payment_systems_settings'),
    columns: 3,
    items: [
      {
        name: 'default_paysystem',
        type: 'select',
        label: i18n.t('resources.default_payment_system'),
        options: [
          {
            value: 'stripe',
            name: i18n.t('resources.stripe'),
          },
          {
            value: 'square',
            name: i18n.t('resources.square'),
          },
        ],
      },
      {
        name: 'payments_in_live_mode',
        type: 'switch',
        label: i18n.t('resources.live_mode'),
        title: i18n.t('resources.live'),
        titleFalse: i18n.t('resources.test'),
        md: 3,
      },
    ],
  },
  webhook: {
    title: i18n.t('resources.block_titles.webhooks'),
    tooltipName: i18n.t('resources.block_titles.webhooks'),
    tooltipText: i18n.t('resources.tooltips.webhook'),
    columns: 10,
    items: [
      {
        name: 'url',
        type: 'url',
        label: i18n.t('resources.url'),
      },
    ],
  },
  blacklist: {
    title: i18n.t('resources.block_titles.black_list'),
    columns: 4,
    items: [
      {
        name: 'domain',
        type: 'text',
        label: i18n.t('resources.domain'),
        tooltipName: 'domain',
        tooltipText: i18n.t('resources.tooltips.black_list.domain'),
      },
      {
        name: 'msg',
        type: 'text',
        label: i18n.t('resources.message'),
        tooltipName: 'msg',
        tooltipText: i18n.t('resources.tooltips.black_list.message'),
      },
      {
        name: 'notify',
        type: 'checkbox',
        className: 'mb-2',
        label: i18n.t('resources.notify'),
      },
    ],
  },
  content_access: {
    title: i18n.t('resources.block_titles.content_access'),
    description: "By default, Wallkit grants perpetual content access, which stays with member even if membership expires. This setting changes the behavior.",
    columns: 4,
    items: [
      {
        name: 'check_access_already_viewed_content',
        type: 'checkbox',
        className: 'mb-2',
        label: i18n.t('resources.general_access.check_access_for_users_who_already_viewed_content'),
      },
    ],
  },
  serviceAccountSettings: {
    columns: 3,
    items: [
      {
        name: 'api_key',
        disabled: true,
        type: 'text',
        label: i18n.t('resources.service_accounts.api_key'),
      },
      {
        name: 'title',
        type: 'text',
        required: true,
        label: i18n.t('resources.service_accounts.title'),
      },
      {
        name: 'description',
        type: 'text',
        label: i18n.t('resources.service_accounts.description'),
      },
      {
        name: 'active',
        type: 'switch',
        title: i18n.t('global.active'),
        titleFalse: i18n.t('global.not_active'),
      },
      {
        name: 'full_access',
        type: 'switch',
        title: i18n.t('resources.service_accounts.full_access'),
      },
    ],
  },
  maskIPsUsers: {
    title: i18n.t('resources.block_titles.ip_mask_settings'),
    columns: 4,
    items: [
      {
        name: 'mask_ip',
        type: 'text',
        label: i18n.t('resources.mask_ip'),
        state: (input) => {
          if (!input || input === '_._._._/_') {
            return true;
          }
          return formMethods.methods.maskIPValidator(input);
        },
        formatter: (input, event) => {
          if (!input && input !== '') {
            format.methods.saveCursorPosition(event.target, 0);
            return '_._._._/_';
          }
          return format.methods.maskIPFormatter(input, event, false);
        },
      },
      {
        name: 'user_id',
        type: 'select',
        label: i18n.t('resources.user_id'),
        options_url: 'users?limit=20',
        filter_field: 'users.global',
        internalSearch: false,
        trackBy: 'value',
        allow_empty: true,
      },
    ],
  },
  ipUsersRange: {
    title: i18n.t('resources.block_titles.ip_users_range'),
    columns: 3,
    items: [
      {
        name: 'ip_from',
        type: 'text',
        label: i18n.t('resources.ip_from'),
        state: (input) => {
          if (!input || input === '_._._._') {
            return true;
          }
          return formMethods.methods.maskIPValidator(input, true);
        },
        formatter: (input, event) => {
          if (input === '') {
            format.methods.saveCursorPosition(event.target, 0);
            return '_._._._';
          }
          return format.methods.maskIPFormatter(input, event, true);
        },
      },
      {
        name: 'ip_to',
        type: 'text',
        label: i18n.t('resources.ip_to'),
        state: (input) => {
          if (!input || input === '_._._._') {
            return true;
          }
          return formMethods.methods.maskIPValidator(input, true);
        },
        formatter: (input, event) => {
          if (input === '') {
            format.methods.saveCursorPosition(event.target, 0);
            return '_._._._';
          }

          return format.methods.maskIPFormatter(input, event, true);
        },
      },
      {
        name: 'user_id',
        type: 'select',
        label: i18n.t('resources.user_id'),
        options_url: 'users?limit=20',
        filter_field: 'users.global',
        internalSearch: false,
        trackBy: 'value',
        allow_empty: true,
      },
    ],
  },
  pricing: {
    title: i18n.t('resources.block_titles.pricing'),
    columns: 6,
    items: [
      {
        name: 'title',
        type: 'text',
        required: true,
        label: i18n.t('wallkit_pricing.fields.title'),
      },
      {
        name: 'description',
        type: 'textarea',
        required: true,
        label: i18n.t('wallkit_pricing.fields.description'),
      },
      {
        name: 'monthly_price',
        type: 'price',
        required: true,
        currency: false,
        label: i18n.t('wallkit_pricing.fields.monthly_price'),
      },
      {
        name: 'transaction_fee',
        type: 'number',
        required: true,
        step: 0.01,
        min: 0,
        max: 100,
        label: i18n.t('wallkit_pricing.fields.transaction_fee'),
      },
      {
        name: 'free_signups',
        type: 'number',
        required: true,
        min: 0,
        label: i18n.t('wallkit_pricing.fields.free_signups'),
      },
      {
        name: 'up_free_signups',
        type: 'number',
        required: true,
        min: 0,
        label: i18n.t('wallkit_pricing.fields.up_free_signups'),
      },
      {
        name: 'up_free_signups_price',
        type: 'price',
        required: true,
        currency: false,
        label: i18n.t('wallkit_pricing.fields.up_free_signups_price'),
      },
      {
        name: 'free_support_hours',
        type: 'number',
        required: true,
        min: 0,
        label: i18n.t('wallkit_pricing.fields.free_support_hours'),
      },
      {
        name: 'up_free_support_price_per_hour',
        type: 'price',
        required: true,
        currency: false,
        label: i18n.t('wallkit_pricing.fields.up_free_support_price_per_hour'),
        wrapLabel: true,
      },
      {
        name: 'available_paywall',
        type: 'switch',
        label: i18n.t('wallkit_pricing.fields.available_paywall'),
        title: i18n.t('global.yes'),
        titleFalse: i18n.t('global.no'),
      },
      {
        name: 'available_ti_event',
        type: 'switch',
        label: i18n.t('wallkit_pricing.fields.available_ti_event'),
        title: i18n.t('global.yes'),
        titleFalse: i18n.t('global.no'),
      },
      {
        name: 'available_reader_id',
        type: 'switch',
        label: i18n.t('wallkit_pricing.fields.available_reader_id'),
        title: i18n.t('global.yes'),
        titleFalse: i18n.t('global.no'),
      },
      {
        name: 'invoice_grace_period_days',
        type: 'text',
        label: i18n.t('wallkit_pricing.fields.invoice_grace_period_days'),
        wrapLabel: true,
      },
      {
        name: 'invoice_charge_automatically',
        type: 'switch',
        label: i18n.t('wallkit_pricing.fields.invoice_charge_automatically'),
        title: i18n.t('global.yes'),
        titleFalse: i18n.t('global.no'),
      },
      {
        name: 'livemode',
        type: 'switch',
        label: i18n.t('resources.live_mode'),
        title: i18n.t('global.yes'),
        titleFalse: i18n.t('global.no'),
      },
    ],
  },
};

export default fields
